document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.getElementById('photo-carousel');
  if (carousel) {
    const carouselInner = carousel.querySelector('.carousel-inner');
    const items = carouselInner.querySelectorAll('.carousel-item');
    let index = 0;
    const totalItems = items.length;
    const itemWidth = items[0].offsetWidth;

    function updateCarousel() {
      carouselInner.style.transform = `translateX(-${index * itemWidth}px)`;
    }

    window.nextSlide = function() {
      index = (index + 1) % totalItems;
      updateCarousel();
    }

    window.prevSlide = function() {
      index = (index - 1 + totalItems) % totalItems;
      updateCarousel();
    }

    updateCarousel();
  }
});
